<template>
    <header class="apn-header">
        <div class="apn-container">
            <router-link to="/" class="apn-logo">
                <img alt="Vue logo" src="../assets/logo.png">
            </router-link>
            <button class="apn-btn-menu" @click="toggle = true">
                <div class="apn-btn-menu--icon"></div>
            </button>
            <div class="layer" :class="{'open': toggle}" @click="toggle = false"></div>
            <nav class="apn-nav" :class="{'open': toggle}">
                <router-link to="/">home</router-link>
                <router-link to="/about">about</router-link>
                <!-- <router-link to="/promotions">promotions</router-link> -->
                <!-- <router-link to="/plans">plans</router-link> -->
                <router-link to="/corporate">corporate</router-link>
                <router-link to="/partners">partners</router-link>
                <router-link to="/faqs">FAQs</router-link>
                <router-link to="/contact">contact</router-link>
                <div class="languages">
                    <!-- :class="{'active': $i18n.locale === 'en'}"
                    :class="{'active': $i18n.locale === 'mm'}" -->
                    <button v-if="$i18n.locale === 'mm'"  @click="setLanguage('en')">Eng</button> 
                    <button v-else  @click="setLanguage('mm')" style="font-size: 14px;">မြန်မာ</button>
                    |
                    <a href="https://isp.myanmarapn.com/portal/login" target="_blank">Login</a>
                </div>
                <button class="apn-btn-close" @click="toggle = false"></button>
            </nav>
        </div>
    </header>
</template>

<script>
export default {
    name: "ApnHeader",
    data() {
        return {
            toggle: false,
        }
    },
    watch: {
        '$route' (to, form) {
            this.toggle = false
            window.scrollTo(0,0)
        }    
    },
    methods: {
        setLanguage(language) {
            this.$i18n.locale = language
            this.toggle = false
        }
    }
};
</script>

<style scoped lang="scss">
.apn-header {
    position: fixed;
    z-index: 5;
    top: 0;
    left: 0;
    width: 100%;
    height: var(--header-height);
    background-color: var(--main-bg);
    box-shadow: 0 3px 6px rgba(0,0,0,0.08), 0 3px 6px rgba(0,0,0,0.1);
    .apn-container {
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .apn-logo {
            img {
                max-height: 40px;
                @media (min-width: 1200px) {
                    max-height: 50px;
                }
            }
        }
        .apn-btn-menu {
            width: 36px;
            height: 36px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            outline: none;
            @media (min-width: 1200px) {
                display: none;
            }
            &::before,
            &::after {
                content: '';
                display: block;
                width: 20px;
                height: 2px;
                background-color: #000;
            }
            .apn-btn-menu--icon {
                width: 20px;
                height: 2px;
                background-color: #000;
                margin: 4px 0;
            }
        }
        .apn-btn-close {
            width: 36px;
            height: 36px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            outline: none;
            position: absolute;
            top: 12px;
            right: 10px;
            @media (min-width: 1200px) {
                display: none;
            }
            &::before,
            &::after {
                content: '';
                display: block;
                position: absolute;
                width: 20px;
                height: 2px;
                background-color: #000;
            }
            &::before {
                transform: rotate(45deg);
            }
            &::after {
                transform: rotate(-45deg);
            }
        }
        .layer {
            position: fixed;
            z-index: 6;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            background-color: #fffa;
            pointer-events: none;
            opacity: 0;
            transition: opacity .3s ease;
            &.open {
                opacity: 1;
                pointer-events: auto;
            }
        }
        .apn-nav {
            @media (max-width: 1199.9px) {
                position: fixed;
                z-index: 7;
                width: 100%;
                max-width: 320px;
                height: 100%;
                top: 0; right: 0;
                background-color: var(--main-bg);
                box-shadow: -10px 0px 20px rgba(0,0,0,0.09), 0 6px 6px rgba(0,0,0,0.1);
                transform: translate(105%, 0);
                transition: transform .2s ease;
                overflow-y: auto;
                
                display: flex;
                flex-direction: column;
                padding: var(--header-height) 40px;
                will-change: transform;
                a {
                    font-family: 'Roboto', 'Padauk', sans-serif;
                    font-size: 24px;
                    padding: 10px;
                    &.router-link-exact-active {
                        color: var(--primary);
                    }
                }
                &.open {
                    transform: translate(0, 0);
                    a {
                        animation-name: FadeIn;
                        animation-timing-function: ease;
                        &:nth-child(1) {
                            animation-duration: .3s;
                        }
                        &:nth-child(2) {
                            animation-duration: .35s;
                        }
                        &:nth-child(3) {
                            animation-duration: .4s;
                        }
                        &:nth-child(4) {
                            animation-duration: .45s;
                        }
                        &:nth-child(5) {
                            animation-duration: .5s;
                        }
                        &:nth-child(6) {
                            animation-duration: .55s;
                        }
                    }
                    .languages {
                        animation: FadeIn .6s ease;
                    }
                }
                .languages {
                    padding: 10px 5px;
                    button {
                        padding: 0 5px;
                    }
                }
            }
            @media (min-width: 1200px) {
                height: 100%;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                a {
                    padding: 0 20px;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    &.router-link-exact-active {
                        background-color: #f4f4f4;
                        position: relative;
                        &::after {
                            content: '';
                            width: 100%;
                            height: 3px;
                            background-color: var(--primary);
                            position: absolute;
                            left: 0; bottom: 0;
                        }
                    }
                }
                .languages {
                    padding: 0 20px;
                    display: flex;
                    button,
                    a {
                        padding: 0 5px;
                    }
                }
            }
            a {
                text-decoration: none;
                color: var(--header-color);
                outline: none;
                text-transform: capitalize;
            }
            .languages {
                button,
                a {
                    font-size: 16px;
                    outline: none;
                    &.active {
                        color: var(--primary);
                    }
                }
            }
        }
    }
    @keyframes FadeIn {
        from, 50% {
            opacity: 0;
            transform: translate(0, -10px);
        }
        to {
            opacity: 1;
            transform: translate(0, 0);
        }
    }
}
</style>
